import { render, staticRenderFns } from "./OringDeatil.vue?vue&type=template&id=bb57933e&scoped=true&"
import script from "./OringDeatil.vue?vue&type=script&lang=js&"
export * from "./OringDeatil.vue?vue&type=script&lang=js&"
import style0 from "./OringDeatil.vue?vue&type=style&index=0&id=bb57933e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb57933e",
  null
  
)

export default component.exports